import type { RouteObject } from 'react-router';

import * as embedSearchJobsHorizonRouteExports from '#/modules/embedSearchWidget/jobs/pages/search/EmbedSearchWidgetSearchJobs.horizon-route';
import * as embedViewJobHorizonRouteExports from '#/modules/embedSearchWidget/jobs/pages/view/EmbedSearchWidgetViewJob.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import {
  embedSearchWidgetJobsRouteGroup,
  embedSearchWidgetSearchJobsRoute,
  embedSearchWidgetViewJobRoute,
} from './embedSearchWidgetJobs.routes';

export const embedSearchWidgetJobsRouteObjects = [
  {
    path: embedSearchWidgetJobsRouteGroup.path,
    children: [
      {
        path: embedSearchWidgetSearchJobsRoute.relativePath,
        ...horizonRouteToObject(embedSearchJobsHorizonRouteExports),
      },
      {
        path: embedSearchWidgetViewJobRoute.relativePath,
        ...horizonRouteToObject(embedViewJobHorizonRouteExports),
      },
    ],
  },
] satisfies RouteObject[];
